

import { useEffect, useRef } from "react";
import gsap from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";



function WelcomeText(){

    const containerRef = useRef<HTMLDivElement>(null);
    const heroRef = useRef<HTMLDivElement>(null);




    return(
        <section ref={containerRef} className="flex flex-col justify-center items-center w-full bg[#00000000] pb-5">
            <div ref={heroRef} className="text-white text-center max-w-6xl p-6 md:p-12 text-lg md:text-xl lg:text-6xl font-light leading-relaxed bg-[#000000bb] ">
                <p>
                    We are RGU Motorsport<br/>
                    A student racing team from Robert Gordon University<br/>
                    Designing, building, and racing our own machines<br/>
                    Powered by engineering and ambition<br/>
                    Driven by speed, precision, and teamwork<br/>
                    Built to compete <br/>
                    Designed to Win
                </p>

            </div>
        </section>
    )
};

export default WelcomeText;